import { fromEvent, from, of, EMPTY } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy, pairwise, catchError,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share, debounceTime } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { gql } from 'apollo-boost';
import client from '../apollo';

import Storage from '@aws-amplify/storage'

const CREATE_OBJECT = gql`
  mutation createTextInstance($text: String!, $tags: [String!]) {
    createTextInstance(text: $text, tags: $tags) {
      success
    }
  }
`;

const CREATE_TASK_INSTANCE = gql`
  mutation createTaskInstance($object: String!, $tags: [String!], $description: String, $name: String!) {
    createTaskInstance(object: $object, tags: $tags, description: $description, name: $name) {
      success
    }
  }
`;
  
const GET_INSTANCES = gql`
{
  objects {
    id
    tags {
      id
    }
    latestState {
      id
      createdAt
      instance {
      __typename
      ... on TextInstance {
        id
        text
      }
      ... on FileInstance {
        id
        description
        url
        key
      }

    }
    }
    states {
      id
      createdAt
      instance {
      __typename
      ... on TextInstance {
        id
        text
      }
      ... on FileInstance {
        id
        description
        url
        key
        fileType
      }
      ... on TaskInstance {
        id
        description
        
      }
    }
    }
  }
}
`;

const GET_STATES = gql`
query states($tags: [String!], $quantity: Int!) {
  states(tags: $tags, quantity: $quantity) {
    id
    createdAt
    object {
      id
      tags
      {
        id
        name
        color
        removeable
      }
    }
    creator {
      name
    }
    instance {
      __typename
      ... on TextInstance {
        id
        text
      }
      ... on FileInstance {
        id
        description
        url
        key
        fileType
      }
      ... on TaskInstance {
        id
        description
        status
        dueDate
        open
      }
    }
  }
}
`;

const refresh$ =
  Dispatch.getState('auth.user')
  .pipe(
    filter(user => user !== null),
    switchMap(e => 
    Rx.merge(
      Dispatch.getAction('Instance', 'created')
      .pipe(
        map(e => 'create')
      ), 
      Dispatch.getAction('Instance', 'refresh')
        .pipe(
          map(e => 'refresh')
      ),
      Dispatch.getState('upload.state').pipe(
        filter(e=> e === 'success'),
        map(e => 'upload')
      ),
      of('initial'),
        Dispatch.getState('Search.tags')
          .pipe(
            map(e => 'search')
          ),
          Dispatch.getState('LoadCount')
          .pipe(
            map(e => 'loadCount')
          )
      )
      .pipe(
        withLatestFrom(Dispatch.getState('LoadCount'), Dispatch.getState('Search.tags'))
      )
    )
  )

refresh$
  .pipe(
    //Debounce time on loading to prevent extra intances from null
    debounceTime(10),
    switchMap(([type, count, search]) => from(client
      .watchQuery({ 
        query: GET_STATES, 
        variables: { tags: Object.keys(search), quantity: count },
        pollInterval: 7000 
      }
      ))
      .pipe(
        catchError(val => EMPTY),
        map(f => f.data.states),
        merge( of(null)
        )
      )
    )
  )
  .subscribe(e => Dispatch.nextState('RawStates', e))

//zip refresh for loading screen? or do null value?

Dispatch.getAction('Instance', 'create')
  .pipe(
    mergeMap(e => {
      if (e.type === 'text') {
        return from(client.mutate({
        mutation: CREATE_OBJECT,
        variables: { text: e.value, tags: Object.keys(e.tags) },
    }))
  }
}
  )
)
.subscribe(e => Dispatch.nextAction('Instance', 'created'))

Dispatch.getAction('Instance', 'createTask')
.pipe(
  mergeMap(e => {
      return from(client.mutate({
      mutation: CREATE_TASK_INSTANCE,
      variables: { object: e.id, tags: {}, description: 'Testing out the tasks yo' , name: 'bob', },
  }))
}
)
)
.subscribe(e => Dispatch.nextAction('Instance', 'created'))


//////////////////////////////////////////////////////////////////////
//DIF LOGIC
const difState = (prev, next, key) => {
  let message = ''
  if (prev.instance.__typename !== next.instance.__typename) {
    message = next.creator.name + ' converted the ' +  prev.instance.__typename + ' to ' + next.instance.__typename + '.'
  }
  else if (next.instance.__typename === 'TextInstance') {
    if (prev.instance.text !== next.instance.text) {
      message = next.creator.name + ' changed text from ' + prev.instance.text + ' to ' + next.instance.text + '.'
    }
  }
  else if (next.instance.__typename === 'TaskInstance') {
    //if (prev.instance.text !== next.instance.text) {
     // message = next.creator + ' changed text from ' + prev.instance.text + ' to ' + next.instance.text
    //}
    message = next.creator.name + ' updated task ' + key + '.'
  }
  return { ...prev, message }
}
    

  Dispatch.getState('RawStates')
  .pipe(
    filter(e => e !== null),
    map(states => _.groupBy(states, state => state.object.id)),
    // map(group => Object.keys(group).map(key => group[key].map((state, index) => { 
    //   return (index === 0) ? state : difState(group[key][index-1], state) })))

    map(group => Object.keys(group).map(key => group[key].map((state, index) => {
      if (index + 1 < group[key].length) {
        return difState(state, group[key][index+1], key)
      }
      else {
        return state
      }
    }))),
    map(objects => _.flatten(objects)),
    map(states => states.reduce((acc, state) => ({ ...acc, [state.id]: {...state } }), {})),
    // Get File Instances
    switchMap(states => {
      const fileStates = Object.keys(states).filter(state => states[state].instance.__typename === 'FileInstance')
      return from(fileStates)
        .pipe(
          mergeMap(state => from(Storage.get(states[state].instance.key.split('/') && states[state].instance.key.split('/')[1], { level: 'public' }))
            .pipe(
              map(e => ({[state]: {...states[state], instance: {...states[state].instance, authUrl: e }}}))
            )
          ),
          scan((acc, next) => ({...acc, ...next}), states), 
          startWith(states)
        )
    }),
    combineLatest(
      Dispatch.getState('TaskBuffer').pipe(startWith({})), 
      Dispatch.getState('Tagger').pipe(startWith({})),
      Dispatch.getState('Tags'),
     // Dispatch.getState('stream').pipe(startWith({}))
    ),
    //FIXME tags are not being applied to all objects, only changed objects (thought it was all objects).
    map(([states, tasks, tags, allTags]) => Object.keys({ ...tasks, ...tags.add, ...tags.remove })
      .filter(key => Object.keys(states).some(stateKey => stateKey === key) )
      .reduce((acc, key) => {
        const insertTasks = (tasks[key] && (tasks[key].saved === false)) ? {...tasks[key], __typename: 'TaskInstance'} : {}
        //const insertTags = tags.add && tags.add[key] ? [tags.add[key]] : []
        const deleteTags = (tags.remove && tags.remove[key] ? tags.remove[key] : []).map(tag => (acc) => {
          const newArray = [...acc]
          const index = _.findIndex(acc, currentTag => currentTag === tag)
          const nothing = index !== -1 ? newArray.splice(index,1) : null
          return newArray
        })
        const insertTags = (tags.add && tags.add[key] ? tags.add[key] : []).map(tag => (acc) => 
        {
          return [...acc, tag]
        })
        //const deleteTags = (tags.remove && tags.remove[key] ? [tags.remove[key]] : []).map(tag => (acc) => acc.splice(_.findIndex(acc, e => tag === acc.id),1))
        
        //const newTagIds = [...insertTags, ...deleteTags].reduce()
        const insertAndRemove = (current) => [...insertTags, ...deleteTags].reduce((acc, next) => next(acc), current)
          //Give all tag info to tags
          .map(tag => allTags[tag])//.filter(value => !_.isNil(value))

        //const newTags = [...states[key].object.tags, ...insertTags].map(tag => allTags[tag]).filter(value => !_.isNil(value))
        return ({ 
          ...acc, 
          [key]: {
            ...states[key], 
            instance: { 
              ...states[key].instance, 
              ...insertTasks 
            },
            object: {
              ...states[key].object,
              tags: insertAndRemove(states[key].object.tags.map(tag => tag.id))
            }
          }
        })
      }, states)
      ),
    combineLatest(Dispatch.getState('buffer')),
    map(([states, buffer]) => {
      const newStates = _.cloneDeep(states)
      Object.keys(buffer).forEach(key => {
        if (!_.isNil(newStates[key]) ){
          if (buffer[key].type === 'textInstance') {
            newStates[key].instance.text = buffer[key].text
          }
        }
        
      })
      return newStates
    }),
    debounceTime(1)
    )
    .subscribe(e => Dispatch.nextState('States', e))

    Dispatch.getState('States')
      .pipe(
        switchMap(states => of(Object.keys(states).map(key => states[key]))
          .pipe(
            map(statesArray => _.sortBy(statesArray, 'createdAt')),
            map(orderedArray => orderedArray.map(e => e.id)),
            map(orderedArray => ({ states: states, order: orderedArray }))
          )
        )
      )
      .subscribe(e => Dispatch.nextState('OrderedStates', e))

    //Dispatch.nextState()
    //map(diffed => _.sortBy(diffed, 'createdAt')),
    
    // Map task changes to task states
    // combineLatest(Dispatch.getState('tasks').pipe(startWith({}))),
    // map(([states, tasks]) => states.map(state => tasks[state.id] ? { ...state, instance: {...state.instance, ...tasks[state.id] }} : state)),
    // Map file urls to file instance states